import { all } from "redux-saga/effects";

export default function* pageSaga() {
  yield all([]);
}
